import { gql, useQuery } from "utils/urql";
import ArticleRelatedContentList from "./ArticleRelatedContentList";
import {
  CuratedRelatedContentQuery,
  CuratedRelatedContentQueryVariables,
} from "types/api";

const CURATED_QUERY = gql`
  ${ArticleRelatedContentList.fragment}

  query CuratedRelatedContentQuery($id: ID!, $preview: String) {
    relatedContent(id: $id, preview: $preview) {
      displayName
      river(first: 3) {
        ...relatedContentRiver
      }
    }
  }
`;

const ArticleRelatedContentCurated = ({
  id,
  preview,
  count,
}: {
  id: string;
  preview?: string | null;
  count: number;
}) => {
  const [{ data }] = useQuery<
    CuratedRelatedContentQuery,
    CuratedRelatedContentQueryVariables
  >({
    query: CURATED_QUERY,
    variables: {
      id,
      preview,
    },
  });
  const content = data?.relatedContent;
  if (!content?.river?.edges.length) return null;
  return (
    <ArticleRelatedContentList
      displayName={content.displayName}
      articles={content.river}
      count={count}
    />
  );
};

export default ArticleRelatedContentCurated;
